<template>
  <div>
    <div @click="showFilePicker" class="c-pointer d-flex position-relative px-2">
      <i class="fa fa-file-o fa-3x fa-vertical-center text-primary"/>
      <div class="d-inline-block position-relative">
        <span class="vertical-center pl-2" v-if="has_files">{{name}}</span>
        <span class="vertical-center pl-2" v-else-if="inputName !== '' && inputName !== undefined">{{inputName}}</span>
        <span class="vertical-center pl-2" v-else>{{$t('app.components.input-file.no-files')}}</span>
      </div>
      <input type="file" class="d-none" @change="fileChange($event)" ref="fileInput" v-bind="inputProps">
    </div>
    <div class="mt-2">
      <button class="btn btn-info bg-info m-0" @click="showFilePicker">{{$t('app.components.input-file.select_PO')}}</button>
      <button type="button" class="btn btn-secondary m-0" @click="clean($event)" v-if="has_files">{{$t('app.components.input-file.clear')}}</button>
    </div>
  </div>
</template>

<script>
import {array_set_value} from "@/util/utilities";

export default {
  name: "FileInput",

  props: {
    inputProps: {
      type: Object,
      default: () => ({})
    },
    inputName: String,

    value: {
      type: Array,
      default: () => []
    }
  },

  data()
  {
    return  {
      fileInput: undefined,
      files: this.value
    }
  },

  mounted()
  {
    this.fileInput = this.$refs.fileInput;
  },

  methods: {
    showFilePicker()
    {
      if (!!this.fileInput)
      {
        this.fileInput.click();
      }
    },

    fileChange(evt){
      this.setFiles( Array.from(evt.target.files) )
    },

    clean(evt)
    {
      evt.stopPropagation();

      if (!!this.fileInput)
      {
        this.fileInput.value = "";
        let event = new Event('change');
        this.fileInput.dispatchEvent(event);
      }
    },

    setFiles(files)
    {
      array_set_value(this.files, files);
    }
  },

  computed: {
    name()
    {
      let names = [];
      if (this.files.length > 0)
      {
        for(let file of this.files)
        {
          names.push(file.name);
        }
      }

      return names.join(', ');
    },

    has_files()
    {
      return this.files.length > 0;
    }
  },

  watch: {
    files(value)
    {
      this.$emit('input', value);
    },

    value(value)
    {
      this.files = value;
    }
  }
}
</script>

<style scoped lang="scss">
  .vertical-center
  {
    position: relative;
    display: inline-block;
    top: 50%;
    transform: translateY(-50%);
  }

  i.fa-vertical-center {
    position: relative;
    &::before
    {
      @extend .vertical-center;
    }
  }
</style>
